{
  "access-denied-user": "Ο χρήστης δεν έχει άδεια πρόσβασης στον ιστό",
  "activation": "Ενεργοποίηση",
  "code": "Κωδικός",
  "code-sent": "Ο κωδικός στάλθηκε",
  "contact": "Επικοινωνία",
  "enter": "Είσοδος",
  "error-text": "Σφάλμα",
  "new-version-available": "Νέα έκδοση διαθέσιμη",
  "password": "Κωδικός πρόσβασης",
  "resend-code": "Επανεκπομπή κωδικού",
  "resend-wait": "Περιμένετε {{seconds}}δ για επανεκπομπή",
  "server-apologies": "Συγγνώμη για την ταλαιπωρία",
  "server-maintenance": "Διακομιστής υπό συντήρηση",
  "translation-load-error": "Σφάλμα κατά τη φόρτωση των μεταφράσεων",
  "user": "Χρήστης",
  "user-or-password-incorrect": "Λανθασμένος χρήστης ή κωδικός πρόσβασης",
  "wait": "Παρακαλώ περιμένετε"
}